import { undo } from '@src/actions/wysiwyg/editor';
import { useContext, useEffect } from 'react';

import { useDispatch } from 'react-redux';

import { WysiwygEditorStateContext } from '@src/contexts/wysiwyg/editor';

export default function KeyBindingUndo({ canUndo }: { canUndo: boolean }) {
  const dispatch = useDispatch();
  const { svgRef } = useContext(WysiwygEditorStateContext);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (!canUndo) return;

      const activeElement = document.activeElement;

      if (
        activeElement &&
        document.activeElement.classList.contains('ProseMirror')
      ) {
        return;
      }

      const os = /Mac|iPod|iPhone|iPad/i.test(navigator.platform)
        ? 'mac'
        : 'win';

      if (
        (os === 'win' &&
          event.ctrlKey &&
          !event.shiftKey &&
          event.key === 'z') ||
        (os === 'mac' && event.metaKey && !event.shiftKey && event.key === 'z')
      ) {
        event.preventDefault();

        svgRef.current.dispatchEvent(new Event('blur-content-items'));
        dispatch(undo());
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [canUndo, dispatch, svgRef]);

  return null;
}
